import React from "react";
import MainLayout from "../../../hoc/main";
import {FormContainer, Grid, Input} from "../../../components";
import {connect} from "react-redux";
import {addCardReaderData} from "../../../redux/modules/CardReader/action";
import {Button} from "../../../components/Button";
import {Redirect} from "react-router-dom";

class CardReaderAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            UNUM: ""
        };
    }

    onChangeValue = (e) => {
        const {value, name} = e.target;

        this.setState({
            [name]: value,
        });
    };

    onChangeCheckBox = (e) => {
        const {checked, name} = e.target;
        this.setState({
            [name]: checked,
        });
    };

    finishForm(e) {
        e.preventDefault();
        this.props.addCardReaderData(this.state);
    }

    render() {
        if (this.props.cardReader?.success) return <Redirect to="/card-reader"/>;
        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <FormContainer className={`pt-0`}>
                        <Input
                            name={"name"}
                            label={"Card Reader name"}
                            value={this.state.name}
                            placeholder={"Lorem"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                        />
                        <Input
                            name={"UNUM"}
                            label={"Card Reader UNUM"}
                            value={this.state.UNUM}
                            placeholder={"Lorem"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                        />

                        <hr className={`my-5`}/>
                        <Button
                            className={`bg-green-200 text-green-700`}
                            onClick={this.finishForm.bind(this)}
                        >
                            Submit
                        </Button>
                    </FormContainer>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    cardReader: state.cardReader,
});

const mapDispatchToProps = {
    addCardReaderData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(CardReaderAdd)
);
